import cn from 'clsx';
import PropTypes from 'prop-types';
import styles from './alert.module.less';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Alert({
  type = 'default',
  className,
  title,
  children,
  ...restProps
}) {
  const alertTitle = title ? title : type.substring(0, 1).toUpperCase() + type.substring(1) + '!';
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.alert, className),
    ...restProps,
    children: [type !== 'default' && /*#__PURE__*/_jsx("strong", {
      className: cn(styles.title, styles[`title--${type}`]),
      children: alertTitle
    }), children]
  });
}
Alert.propTypes = {
  type: PropTypes.oneOf(['default', 'danger', 'success', 'warning']),
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any
};